import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { forwardRef, useRef, useState } from 'react';


const InputWithLabel = forwardRef(
  (
    {
      type = 'text',
      variant = 'underline',
      placeholder,
      error = false,
      classes,
      value,
      readOnly = false,
      onChange,
      onInvalid,
      required,
      setValue,
      setValueName,
      label,
      rightIcon, // 이미지 URL 또는 이모지 문자열
      rightIconNode, // React 노드 (이미지 컴포넌트 등)
      ...props
    },
    ref,
  ) => {
    const defaultRef = useRef();
    const inputRef = ref ?? defaultRef;
    const [isFocused, setIsFocused] = useState(false);
    
    // 오른쪽 아이콘 렌더링
    const renderRightIcon = () => {
      if (rightIconNode) {
        return rightIconNode;
      }
      if (rightIcon) {
        // 이미지 URL인지 이모지인지 판단
        if (rightIcon.startsWith('http') || rightIcon.startsWith('/') || rightIcon.startsWith('./') || rightIcon.startsWith('../')) {
          return <img src={rightIcon} alt="" style={{ width: '20px', height: '20px', objectFit: 'contain' }} />;
        } else {
          // 이모지인 경우
          return <span style={{ fontSize: '20px', lineHeight: '1' }}>{rightIcon}</span>;
        }
      }
      return null;
    };

    const hasRightIcon = rightIcon || rightIconNode;

    return (
      <div
        className={classNames(
          error && 'error',
          classes,
          'input'
        )}
      >
        <div style={{marginBottom: '5px'}}>
          <span style={{color: '#777'}}>{label}</span>
        </div>
        
        <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
          <input
            ref={inputRef}
            value={value}
            type={type}
            onChange={(e) => {
              onChange(e)
            }}
            placeholder={placeholder}
            readOnly={readOnly}
            className={classNames(
              classes
            )}
            style={{
              ...(hasRightIcon && { paddingRight: '40px' }),
              ...props.style
            }}
            autoComplete='new-password'

            onInput={e => {
              if (['number', 'tel'].includes(type)) {
                const target = e.currentTarget;
                const hasInvalidKey = /[^0-9]/g.test(target.value);

                if (hasInvalidKey) {
                  const { selectionStart } = target;
                  target.value = target.value.replace(/[^0-9]*/g, '');
                  if (typeof selectionStart === 'undefined' || selectionStart === null) {
                    target.setSelectionRange(selectionStart - 1, selectionStart - 1);
                  }
                  e.preventDefault();
                }
              }
              props.onInput?.(e);
            }}
            onFocus={e => {
              setIsFocused(true);
              props.onFocus?.(e);
            }}
            onBlur={e => {
              setIsFocused(false);
              props.onBlur?.(e);
            }}
            {...props}
          />
          {hasRightIcon && (
            <div style={{
              position: 'absolute',
              right: '12px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              pointerEvents: 'none',
              userSelect: 'none'
            }}>
              {renderRightIcon()}
            </div>
          )}
        </div>
        {error.message && <span className={classNames('error')}>{error.message}</span>}
      </div>
    );
  },
);
export default InputWithLabel;

InputWithLabel.propTypes = {
  type: PropTypes.oneOf(['text', 'number', 'email', 'password', 'search', 'tel']),
  variant: PropTypes.oneOf(['underline', 'white', 'grey']),
  showDelete: PropTypes.bool,
  leftIconNode: PropTypes.node,
  rightIconNode: PropTypes.node,
  rightIcon: PropTypes.oneOfType([PropTypes.string, PropTypes.node]), // 이미지 URL 또는 이모지 문자열
  classes: PropTypes.string,
};
